module.exports = __webpack_public_path__ + "img/blank.dfc784e9.jpg";